

export const  VIDEO_SHOT_FETCHING = "VIDEO_SHOT_FETCHING"
export const  VIDEO_SHOT_FETCHED = "VIDEO_SHOT_FETCHED"
export const  VIDEO_SHOT_FAILED = "VIDEO_SHOT_AILEDG"